/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import type { TabValue } from "../config";
import { TAB_CONFIG } from "../config";

interface EmptyStateProps {
  tab: TabValue;
  hasDateFilter: boolean;
  hasSearchQuery: boolean;
}

export const EmptyState = defineComponent<EmptyStateProps>({
  name: "EmptyState",
  props: ["tab", "hasDateFilter", "hasSearchQuery"] as any,
  setup(props) {
    const { t } = useLocalization();

    return () => {
      const config = TAB_CONFIG[props.tab];

      return (
        <div class="flex items-center justify-center h-full min-h-[400px]">
          <div class="text-center max-w-md">
            <div class="w-16 h-16 rounded-full bg-base-200 flex items-center justify-center mx-auto mb-4">
              <span class="material-symbols-outlined text-base-content/30 text-3xl">
                {props.tab === "reservations" ? "event" : "mail"}
              </span>
            </div>
            <h3 class="font-medium text-accent mb-1">
              {t(config.emptyTitleKey)}
            </h3>
            <p class="text-sm text-base-content/60">
              {props.hasSearchQuery
                ? t("reservations.history.adjust_filters")
                : props.hasDateFilter
                  ? t(config.emptyDescriptionKey)
                  : t(config.emptyDescriptionKey)}
            </p>
          </div>
        </div>
      );
    };
  },
});
